import axios from "axios";

const API_URL = "https://seltentechnologiesdemo.com/moona-backend/linkFamilyMembers.php";

export const linkFamilyAPI = async (payload) => {
  try {
    const res = await axios.post(API_URL, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    console.error("API ERROR:", err);
    return { error: err.message };
  }
};
